import { Component } from '@angular/core';
import { SettingsOption } from 'src/app/enums/settings';
import { PermissionsService } from '../../services/permissions.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
  readonly SettingsOption = SettingsOption;
  selectedComponent!: SettingsOption;

  componentMapping: Record<SettingsOption, string> = {
    /*
        [SettingsOption.SECTIONS]: 'app-sections',
        [SettingsOption.PERMISIUNI]: 'app-permisiuni',
        [SettingsOption.PERMISIUNI_ACTIUNI]: 'app-permisiuni-actiuni',
        [SettingsOption.FUNCTII]: 'app-functii',
        */
    [SettingsOption.JUDET]: 'app-judet',
    [SettingsOption.CERERE_PRIORITY]: 'app-cerere-priority',
    [SettingsOption.STATUS]: 'app-status',
    [SettingsOption.REQUEST_TYPES]: 'app-request-types',
    [SettingsOption.CERERE_SABLOANE]: 'app-cerere-sabloane',
    [SettingsOption.DOCUMENT_CATEGORY]: 'app-document-category',
    [SettingsOption.DOCUMENT_TYPE]: 'app-document-type',
    [SettingsOption.DOCUMENT_TEMPLATE]: 'app-document-template',
    [SettingsOption.REGISTRE]: 'app-registre',
    [SettingsOption.OPERATORI]: 'app-operatori',
    [SettingsOption.ZILE_LIBERE]: 'app-zile-libere',
    /*
        [SettingsOption.PLATFORM_SECTION]: 'app-platform-section',
        [SettingsOption.PLATFORM_FAQ]: 'PLATFORM_FAQ',
        [SettingsOption.PLATFORM_CONTENT]: 'app-platform-content',
        [SettingsOption.PLATFORM_ANNOUNCES]: 'app-platform-announces',
        */
  };
  componentKeys: string[] = Object.keys(this.componentMapping);

  onChange($event: { value: any }) {
    this.selectedComponent = $event.value;
  }

  selectedSection: any = null;

  constructor(private permissionsService: PermissionsService) {
    this.filterComponents();
  }

  filterComponents() {
    if (
      !this.permissionsService.hasPermission(
        'urbanism-module.settings.judet.list'
      )
    ) {
      this.componentKeys = this.componentKeys.filter(
        (item) => item !== SettingsOption.JUDET
      );
    }
    if (
      !this.permissionsService.hasPermission(
        'urbanism-module.settings.prioritati-cerere.list'
      )
    ) {
      this.componentKeys = this.componentKeys.filter(
        (item) => item !== SettingsOption.CERERE_PRIORITY
      );
    }
    if (
      !this.permissionsService.hasPermission(
        'urbanism-module.settings.status-cerere.list'
      )
    ) {
      this.componentKeys = this.componentKeys.filter(
        (item) => item !== SettingsOption.STATUS
      );
    }
    if (
      !this.permissionsService.hasPermission(
        'urbanism-module.settings.tip-cerere.list'
      )
    ) {
      this.componentKeys = this.componentKeys.filter(
        (item) => item !== SettingsOption.REQUEST_TYPES
      );
    }
    if (
      !this.permissionsService.hasPermission(
        'urbanism-module.settings.sabloane-cerere.list'
      )
    ) {
      this.componentKeys = this.componentKeys.filter(
        (item) => item !== SettingsOption.CERERE_SABLOANE
      );
    }
    if (
      !this.permissionsService.hasPermission(
        'urbanism-module.settings.categorii-documente.list'
      )
    ) {
      this.componentKeys = this.componentKeys.filter(
        (item) => item !== SettingsOption.DOCUMENT_CATEGORY
      );
    }
    if (
      !this.permissionsService.hasPermission(
        'urbanism-module.settings.tip-documente.list'
      )
    ) {
      this.componentKeys = this.componentKeys.filter(
        (item) => item !== SettingsOption.DOCUMENT_TYPE
      );
    }
    if (
      !this.permissionsService.hasPermission(
        'urbanism-module.settings.template-documente.list'
      )
    ) {
      this.componentKeys = this.componentKeys.filter(
        (item) => item !== SettingsOption.DOCUMENT_TEMPLATE
      );
    }
    if (
      !this.permissionsService.hasPermission(
        'urbanism-module.documents.official-documents-registry.list'
      )
    ) {
      this.componentKeys = this.componentKeys.filter(
        (item) => item !== SettingsOption.REGISTRE
      );
    }
    if (
      !this.permissionsService.hasPermission(
        'urbanism-module.settings.operatori.list'
      )
    ) {
      this.componentKeys = this.componentKeys.filter(
        (item) => item !== SettingsOption.OPERATORI
      );
    }
    // if (
    //   !this.permissionsService.hasPermission(
    //     'urbanism-module.settings.zile-libere.list'
    //   )
    // ) {
    //   this.componentKeys = this.componentKeys.filter(
    //     (item) => item !== SettingsOption.ZILE_LIBERE
    //   );
    // }
  }
}
